import { render, staticRenderFns } from "./OldEntityList.vue?vue&type=template&id=1d2bfcfb&lang=pug"
import script from "./OldEntityList.vue?vue&type=script&lang=js"
export * from "./OldEntityList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports